import { TbNotes } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const NoteIcon = (props: IconProps) => {
  return <IconBase icon={TbNotes} {...props} />;
};
